import request from './request';

export async function list(
  page: number,
  perPage: number,
  email?: string,
  name?: string,
  phone?: string,
  types?: string[],
  message?: string,
  sortColumn?: string,
  sortOrder?: string,
  createdAtFilter?: number[]
) {
  return request('GET', '/api/contact-requests', {
    page,
    perPage,
    email,
    name,
    phone,
    types,
    message,
    sortColumn,
    sortOrder,
    createdAtFilter,
  });
}
